var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.9004H4.5C3.675 22.9004 3 22.2254 3 21.4004V8.65039H4.5V21.4004H13.5V22.9004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.9004H7.5C6.675 19.9004 6 19.2254 6 18.4004V5.65039H7.5V18.4004H16.5V19.9004Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.6504H12V13.1504H18V11.6504Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.775 6.62539L15.525 1.37539C15.375 1.22539 15.225 1.15039 15 1.15039H10.5C9.675 1.15039 9 1.82539 9 2.65039V15.4004C9 16.2254 9.675 16.9004 10.5 16.9004H19.5C20.325 16.9004 21 16.2254 21 15.4004V7.15039C21 6.92539 20.925 6.77539 20.775 6.62539ZM15 2.95039L19.2 7.15039H15V2.95039ZM19.5 15.4004H10.5V2.65039H13.5V7.15039C13.5 7.97539 14.175 8.65039 15 8.65039H19.5V15.4004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentationIcon);
export default __webpack_public_path__ + "static/media/ic-documentation-icon.64aa9930664d97cef735b92a1b26e6e3.svg";
export { ForwardRef as ReactComponent };